import { Modal } from 'antd';
import React, { useEffect } from 'react';

const PlayVideoModal = ({ videoURL, playVideo, closeVideoModal }) => {
  return (
    <Modal open={playVideo} title={null} okText={null} cancelText={null} onCancel={closeVideoModal} footer={null}>
      <div className="mt-4 flex items-center justify-center">
        <video src={videoURL} controls />
      </div>
    </Modal>
  );
};

export default PlayVideoModal;
